import { useEffect, useState } from "react";
import { useAuth } from "@/providers/AuthProvider";
import { fetchWithSessionSync } from "@/lib/fetch-with-session";
import { DashboardPageShell } from "@/components/dashboard/dashboard-page-shell";
import { ScheduleManager } from "@/components/dashboard/schedule-manager";
import { LoadingFrame } from "@/components/ui/loading-frame";

type ScheduleRow = {
  id: string;
  dayOfWeek: number;
  startTime: string;
  endTime: string;
  slotDuration: number;
  interval: number;
};
export function DashboardSchedule() {
  const { refresh } = useAuth();
  const [data, setData] = useState<{ schedules: ScheduleRow[] } | null>(null);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      const r = await fetchWithSessionSync("/api/dashboard/schedule", { credentials: "include" }, refresh);
      if (cancelled) return;
      if (!r.ok) return;
      setData((await r.json()) as { schedules: ScheduleRow[] });
    })();
    return () => {
      cancelled = true;
    };
  }, [refresh]);

  if (!data) {
    return (
      <DashboardPageShell eyebrow="Disponibilidad" title="Horarios">
        <LoadingFrame variant="light" minHeight={320} />
      </DashboardPageShell>
    );
  }

  return (
    <DashboardPageShell
      eyebrow="Disponibilidad"
      title="Horarios"
      description="Definí en qué días atendés. Para bloquear fechas usá Inhabilitar fechas en el menú de configuración."
    >
      <ScheduleManager schedules={data.schedules} />
    </DashboardPageShell>
  );
}
